module.exports = __webpack_public_path__ + "img/error_404.c2db68b1.svg";